import React, { Component } from 'react';
import { format } from "date-fns";
import { Link } from 'react-router-dom';
import { Big3DatePicker, ComboBox, BookMarkStore, NoResult, GoodsPhoto, Alert, Confirm } from "../../../js/ComponentManager";
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { OrderMgrDtl } from './OrderMgrDtl'
/* 개발담당:양유빈
 * 화면기능:주문내역 리스트
 * 세부설명:
 * 
 * 마스터 완료/미완료:  상세내역에 모든것 들이 완료 될때 완료+사입완료 까지
    사입: 수정(처리 전:OD)/전달(CP)
    전체취소: 사입(대리주문 같은) 1건 
*/

export class OrderMgrList extends Component {
    static displayName = OrderMgrList.name;

    constructor(props) {
        super(props);
        
        let fromDate = format(Big3Common.Util.DateAdd(new Date(), -3), "yyyy-MM-dd");
        let toDate = format(Big3Common.Util.DateAdd(new Date(), 1), "yyyy-MM-dd");
        this.OrderMgrDtlRef = React.createRef();
        //CancelListYn은 취소목록 보기 속성 임.
        this.state = {
            OrdMgtMaster: [],
            DetailPlatform: [],
            DetailNote: [],
            SumBuyamt:0,
            FromDate: fromDate,
            ToDate: toDate,
            SearchText: "",            
            Content: "",
            CancelListYn:"N",  
            isOk: false
        };
        this.SelectOrd_Idx = "";
        this.CsName = Big3Common.ContentState;
        this.handleCalendarChange = this.handleCalendarChange.bind(this);
        this.handleSearchText_Change = this.handleSearchText_Change.bind(this);
        this.handleSearchText_Keyup = this.handleSearchText_Keyup.bind(this);
        this.handleCombo_Change = this.handleCombo_Change.bind(this);
        this.handleExpand_Click = this.handleExpand_Click.bind(this);
        this.handleMemo_Change = this.handleMemo_Change.bind(this);
        this.handleMemoSave_Click = this.handleMemoSave_Click.bind(this);
        this.handleCancel_Click = this.handleCancel_Click.bind(this);
        this.handleOrderDtl_Click = this.handleOrderDtl_Click.bind(this);
        this.handleComplete_Click = this.handleComplete_Click.bind(this);
        this.handleTab_Click = this.handleTab_Click.bind(this);
        this.Uid_Type = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.Uid_Type)
    }
    //사입일자 가져오기
    async GetOrderDate() {
        
        const SearchModel = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.SearchModel, null);
        if (SearchModel !== null) {
            const FromDate = SearchModel.FromDate;
            const ToDate = SearchModel.ToDate;
            const SearchText = SearchModel.SearchText;
            const CancelListYn = SearchModel.CancelListYn;
            this.setState({
                ToDate: ToDate,
                FromDate: FromDate,
                SearchText: SearchText,
                CancelListYn: CancelListYn
            });
        }
        else {
            try {
                let Data1 = await Big3Common.Get('api/Common/Common/GetOrderDate');
                if (Data1.codeName === Big3Common.ResultCode.Success) {
                    const toData = Data1.message;
                    let fromDate = format(Big3Common.Util.DateAdd(new Date(toData), -3), "yyyy-MM-dd");
                    this.setState({
                        ToDate: toData,
                        FromDate: fromDate
                    });
                }
            }
            catch (e) {
                console.log("GetOrderDate", e);
            }
        }
        
        return false;
    }
    //초기화
    OrdIdx= []
    async componentDidMount() {
        await this.GetOrderDate();

        try {
            //주문구분 콤보
            let Data1 = await Big3Common.Get('api/Common/Common/GetBaseInfo/009');
            if (Data1.codeName === Big3Common.ResultCode.Success) {
                let OrdIdx = JSON.parse(Data1.dataTable);
                this.OrdIdx = OrdIdx;
            }
            else {
                console.log(Data1.message);
            }
        }
        catch (e) {
            console.log("componentDidMount", e);
        }
        this.CallOrdMgtListData()
    }
    //주문내역 가져오기
    async CallOrdMgtListData(CancelListYn="") {
        try {

            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/MyPage/OrderMgr/GetOrdMgtList',
                {
                    FromDate: this.state.FromDate,
                    ToDate: this.state.ToDate,
                    SearchText: this.state.SearchText,
                    Ord_Idx: this.SelectOrd_Idx,
                    CancelListYn: CancelListYn === "" ? this.state.CancelListYn : CancelListYn
                }, true);
           
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.multiDataTable);
                this.setState({
                    OrdMgtMaster: DataList.Master,
                    DetailPlatform: DataList.DetailPlatform,
                    DetailNote: DataList.DetailNote,
                    SumBuyamt: DataList.SumBuyamt
                });
              
            }
            else if (Data.codeName === Big3Common.ResultCode.Warning)
            {
                this.setState({ Content: Data.message });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallOrdMgtListData", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    //달력일자 선택
    handleCalendarChange(retunData) {
        this.setState({ [retunData.returnId]: retunData.SelectDate });
    }
    //상품명 검색 값
    handleSearchText_Change(event) {
        let Value = event.target.value;
        this.setState({ SearchText: Value });
    }
    handleSearchText_Keyup(event) {
        if (event.keyCode === 13) {
            this.CallOrdMgtListData();
        }
        event.preventDefault();
    }
    //주문구분값 할당
    handleCombo_Change(event) {
        let target = event.target;
        let value = target.value.trim();   
        this.SelectOrd_Idx = value;
        this.CallOrdMgtListData();
    }
    //확장버큰 클릭
    handleExpand_Click(event,list) {
        if (list.selected === true) {
            list.selected = false;
        }
        else {
            list.selected = true;
        }
        this.setState({ isOk: true });
        event.preventDefault();
    }
    //소매 메모전달,추가
    handleMemo_Change(event, NoteData) {
        let target = event.target;
        let value = target.value.trim();
        NoteData.retail_memo_modify = value;
        event.preventDefault();
    }
    //상품 상세보기
    handleOrderDtl_Click(event, list) {
        this.OrderMgrDtlRef.current.CallOrdMgtMstDtlRef(list.uid, list.ordgrp_no);
        Big3Common.ModalAlert(bootstrap, "OrderMgrDtl");
        event.preventDefault();
    }
    //메모저장
    async handleMemoSave_Click(event, NoteData, txtID) {
        
        try {
            if (NoteData.retail_memo_modify.trim() === "") {
                this.setState({ Content: "메모내용을 입력하여 주세요." });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
                return false;
            }
            else {
                let Data = await Big3Common.Post('api/MyPage/OrderMgr/ModifyRetailMemo',
                    {
                        order_code: NoteData.order_code,
                        retail_memo_modify: NoteData.retail_memo_modify
                    }, true);
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    const appr_status = NoteData.last_appr_status;
                    const retail_memo = NoteData.retail_memo;
                    const retail_memo_modify = NoteData.retail_memo_modify;
                    if (appr_status === "OD" || retail_memo === "") {
                        NoteData.retail_memo = retail_memo_modify;
                    }
                    else {
                        NoteData.retail_memo = `${retail_memo} / ${retail_memo_modify}`;
                    }
                    this.setState({ isOk: true });
                }
                else {
                    console.log(Data.message);
                }
            }

        }
        catch (e) {
            console.log("handleMemoSave_Click", e);
        }
        finally {
            document.getElementById(txtID).value = "";
            NoteData.retail_memo_modify = "";
        }
        event.preventDefault();
    }
    //주문취소
    DeleteModel = {
        uid:"",
        ordgrp_no: "",
        order_code: "",
        type: "",
        ord_dt: ""
    };
    handleCancel_Click(DelData, Type) {
        
        if (Type === "SP") {
            //상품리스트 삭제 클릭
            this.DeleteModel.uid = DelData.uid;
            this.DeleteModel.ordgrp_no = DelData.ordgrp_no;
            this.DeleteModel.ord_dt = DelData.ord_dt;
            this.DeleteModel.type = Type;
        }
        else {
            //사입내역 삭제 클릭
            this.DeleteModel.order_code = DelData.order_code;
            this.DeleteModel.ord_dt = DelData.order_dt;
            this.DeleteModel.type = Type;
        }
        Big3Common.ModalAlert(bootstrap, "CancelConfirm");
        return false;
    }
  //취소처리 Rest전송--> Confirm창 취소 실행
  async handleCancel_Post() {
        try {
            let Data = await Big3Common.Post('api/MyPage/OrderMgr/CancelOrdMgt', this.DeleteModel,true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ Content: Data.message });
                Big3Common.ModalAlert(bootstrap, "CompleteCancel");
                this.CallOrdMgtListData();
            }
            else {
                this.setState({ Content: Data.message });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
            }
        }
        catch (e) {
            console.log("handleCancel_Post", e);
        }
        finally {
            this.DeleteModel.uid = "";
            this.DeleteModel.ordgrp_no = "";
            this.DeleteModel.order_code = "";
            this.DeleteModel.type = "";
      }
      return false;
        
    }
    //수령완료 처리 모델
    Ord_Status_Model = {
        Uid: "",
        Ordgrp_No: "",
        Ord_Status:""
    }
    //수정완료 처리
    handleComplete_Click(list, Ord_Status) {
        this.Ord_Status_Model.Uid = list.uid;
        this.Ord_Status_Model.Ordgrp_No = list.ordgrp_no;
        this.Ord_Status_Model.Ord_Status = Ord_Status;
        Big3Common.ModalAlert(bootstrap, "CompleteConfirm");
        return false;
    }
    async handleComplete_Post() {
        try {
            let Data = await Big3Common.Post('api/MyPage/OrderMgr/ModifyOrderMgtStatus', this.Ord_Status_Model, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.CallOrdMgtListData();
            }
            else {
                this.setState({ Content: Data.message });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
            }
        }
        catch (e) {
            console.log("handleComplete_Post", e);
        }
        finally {
            this.Ord_Status_Model.Uid = "";
            this.Ord_Status_Model.Ordgrp_No = "";
            this.Ord_Status_Model.Ord_Status = "";
        }
        return false;
    }
    handleTab_Click(event, CancelListYn) {
        this.setState({ CancelListYn: CancelListYn });
        this.CallOrdMgtListData(CancelListYn);
        event.preventDefault();
    }
    //사입내역 조회
    BuyerOrderrender(masterRow) {
        //마스터가 클릭 할때 데이터 표시
        if (masterRow.selected === false) {
            return false;
        }
        
        //사입데이터 조회
        let DetailNote = this.state.DetailNote.filter(Note => Note.order_code === masterRow.order_code);
        if (DetailNote.length > 0 && DetailNote[0].uid_type !== 'TS') {
            let DetailNoteData = DetailNote[0];
            const txtID =`txtMemo_${DetailNoteData.order_code}`
            return (
                <div className="detail_list_box">
                    <div className="price_info">사입주문({DetailNoteData.appr_status_nm})</div>
                    <div className="shop_memo_info smf2">대납비 : {Big3Common.Util.Money(DetailNoteData.buy_amt)}원</div>
                    <div className="shop_memo_info smf2">사입메모 : {DetailNoteData.buy_memo}</div>
                    <div className="shop_memo_box smf2">소매메모 : {DetailNoteData.retail_memo}</div>
                    <div className="shop_memo_input_box">
                        <label>{DetailNoteData.last_appr_status === "OD" ? "메모추가" : "메모수정"}</label>
                        <input type="text" placeholder="메모를 입력해주세요"
                            maxLength={100}
                            id={txtID }
                            onChange={(e) => { this.handleMemo_Change(e, DetailNoteData); }}
                            className="form-control" />
                        {this.state.CancelListYn === "Y" ? "" : <button onClick={(e) => { this.handleMemoSave_Click(e, DetailNoteData, txtID) }}>전달</button>}
                    </div>
                    {DetailNoteData.return_yn === "Y" ? <div className="return">반품/교환</div> : ""}
                    {DetailNoteData.last_appr_status === "CP" || this.state.CancelListYn === "Y" ? "" : <div className="order_cacel_btn" onClick={() => { this.handleCancel_Click(DetailNoteData, 'SI') }}>주문취소</div>}
                </div>
            )
        }
        else if (DetailNote.length > 0 && DetailNote[0].uid_type === 'TS') {
            let DetailNoteData = DetailNote[0];
            const txtID = `txtMemo_${DetailNoteData.order_code}`
            return (
                <div className="detail_list_box">
                    <div className="price_info">택배주문({DetailNoteData.appr_status_nm})</div>
                    <div className="shop_memo_info smf2">사입메모 : {DetailNoteData.buy_memo}</div>
                    <div className="shop_memo_box smf2">소매메모 : {DetailNoteData.retail_memo}</div>
                    <div className="shop_memo_input_box">
                        <label>{DetailNoteData.last_appr_status === "OD" ? "메모추가" : "메모수정"}</label>
                        <input type="text" placeholder="메모를 입력해주세요"
                            maxLength={100}
                            id={txtID}
                            onChange={(e) => { this.handleMemo_Change(e, DetailNoteData); }}
                            className="form-control" />
                        {this.state.CancelListYn === "Y" ? "" : <button onClick={(e) => { this.handleMemoSave_Click(e, DetailNoteData, txtID) }}>전달</button>}
                    </div>
                    {DetailNoteData.return_yn === "Y" ? <div className="return">반품/교환</div> : ""}
                    {DetailNoteData.last_appr_status === "CP" || this.state.CancelListYn === "Y" ? "" : <div className="order_cacel_btn" onClick={() => { this.handleCancel_Click(DetailNoteData, 'SI') }}>주문취소</div>}
                </div>
            )
        }
        else {
            return (
                ""
            )
        }
    }
    //도매별>상품그룹별 리스트
    OrderDetailrender(masterRow) {       
        //순수 사입주문 일경우 uid가 없음.
        if (masterRow.uid === "") {
            return false;
        }
        if (masterRow.selected === false) {
            return false;
        }
        let DataDetail = this.state.DetailPlatform.filter(filter => filter.uid === masterRow.uid && filter.ord_dt === masterRow.ord_dt);
        this.CancelButton = (list) => {
            if (list.ord_status === "JM") {
                return (
                    <div className="order_cacel_btn" onClick={() => { this.handleCancel_Click(list, 'SP') }}>주문취소</div>
                )
            }
            else if (list.ord_status === "PJ") {
                return (
                    <div className="order_confirm_btn" onClick={() => { this.handleComplete_Click(list, 'GR') }}>수령완료</div>
                )
            }
            else {
                return (
                    ""
                )
            }
        }
        return (
            <> 
                {DataDetail.map(list =>
                    <div className="detail_list_box" key={list.ordgrp_no}>
                        <GoodsPhoto className="img"
                            ImageSrc={list.img_220}
                        />
                        <div className="detail_info">
                            <div className="item_info_box">
                                <div className="item_info">{list.goods_names}</div>
                                {list.ord_status === "JM" ? <p className="new"></p> : "" }
                            </div>
                            <div className="price_info">{Big3Common.Util.Money(list.goods_price_tot)}원</div>
                            <div className="price_info">{list.ord_status === "GR" ? list.ord_status_nm : list.ord_use_nm}</div>
                            <div className="detail_view_btn" onClick={(e) => { this.handleOrderDtl_Click(e, list); }}>상세보기</div>
                            {this.CancelButton(list)}
                        </div>
                    </div>
                )}
            </>
        )
    }
     
    //일자별 > 도매별 리스트
    WholeInforender(Wholelist) {
        
        //완료, 미완료 값 반환
        this.OrderCompleteYn = "N";
        this.OrderComplete = (DataList) => {
            if (this.state.CancelListYn === "Y") {
                return (
                    <div className="all_cancel Incomplete">취소</div>
                )
            }
            else {
                let BuyerCount = 0;
                let BuyerCountCP = 0;
                let PlatCount = 0;
                let PlatCountGR = 0;
                if (DataList.uid === "" && this.state.DetailNote.length > 0) {
                    //사입 데이터 카운팅
                    BuyerCount = this.state.DetailNote.filter(data => data.order_code === DataList.order_code).length;
                    //사입데이터 완료 카운팅
                    BuyerCountCP = this.state.DetailNote.filter(data => data.order_code === DataList.order_code && data.last_appr_status === "CP").length;
                }
                else {
                    //플랫폼 데이터 카운팅
                    PlatCount = this.state.DetailPlatform.filter(data => data.uid === DataList.uid && data.ord_dt === DataList.ord_dt).length;
                    //플랫폼 데이터 완료 카운팅
                    PlatCountGR = this.state.DetailPlatform.filter(data => data.uid === DataList.uid && data.ord_dt === DataList.ord_dt && data.ord_status === "GR").length;
                }
                let TotalOrder = BuyerCount + PlatCount;
                let TotalComplete = BuyerCountCP + PlatCountGR;
                if (TotalOrder === TotalComplete) {
                    this.OrderCompleteYn = "Y"; //완료
                    return "Y";
                }
                else {
                    this.OrderCompleteYn = "N";//미완료
                    return "N";
                }
            }
        }
        this.OrderIcon = (idx_list) => {
            let idxList = idx_list.split(',').reverse();
            //EX, SI, SP,SS(상품인데 사입전달)
            return (
                <>
                    {
                        idxList.map(list =>
                            <div key={list}>
                                {list === "SI" ? <div className="order_type_icon buyer"></div> : ""}
                                {list === "SS" ? <div className="order_type_icon buyer2"></div> : ""}
                                {list === "SP" ? <div className="order_type_icon goods"></div> : ""}
                                {list === "EX" ? <div className="order_type_icon excel"></div> : ""}
                            </div>
                        )
                    }
                </>
            )
        }
        //취소탭은 완료/미완료 표시 안함.
        this.CompleteLabel = (OrderCompleteYn) => {
            if (this.state.CancelListYn === "N") {
                return OrderCompleteYn === "Y" ? "완료" : "미완료";
            }
            return ""
        }
        //채팅창 이동
        this.Chat_Link = (uid) => {
            if (uid === "" || uid === null) {
                return (
                    ""
                )
            }
            else {
                return (
                    <Link to={`/Chat/LiveChat/Index?uid=${uid}`}>
                        <div className="chat_icon"></div>
                    </Link>
                )
            }
        }
        //홈페이지 이동
        this.Home_Link = (uid, whole_name) => {
            if (uid === "" || uid === null) {
                return (
                    <div className="shop_name">{whole_name}</div>
                )
            }
            else {
                return (
                    <Link to={`/Search/Goods/Index?Uid=${uid}`}>
                        <div className="shop_name">{whole_name}</div>
                    </Link>
                )
            }
        }
        return (
           
            <>
                {Wholelist.map(list =>
                    <div className="order_shop_box" key={`${list.ord_dt}_${list.whole_code}`}>
                        <div className="order_shop_name_box">
                            {this.Home_Link(list.uid, list.whole_name)}
                            {this.OrderComplete(list) === "N" ? <p className="new"></p> :""}
                            <div className="shop_icon">
                                <BookMarkStore
                                    Whole_Code={list.whole_code}
                                    HeartOn={list.bookmark_yn === "Y" ? true : false}
                                    CheckCss="icon2_checked"
                                    UnCheckCss="icon2"
                                />
                                <div className="icon1" onClick={() => { window.location.href = `tel:${list.user_phone}` }}></div>
                                {this.Chat_Link(list.uid) }
                            </div>
                        </div>
                        <div className="order_shop_add">{list.bld_name} {list.flr_name}층 {list.whole_no_name}호</div>
                        <div className="order_status_box">
                            <div className="order_type">{this.OrderIcon(list.ord_idx_list)}</div>
                            <div className="order_status">{this.CompleteLabel(this.OrderCompleteYn)}</div>
                        </div>
                        
                        {this.OrderDetailrender(list)}
                        {this.BuyerOrderrender(list)}
                        <div className="order_detail_btn" onClick={(e) => { this.handleExpand_Click(e, list) }}>{list.selected === true ? "접기" : "상세보기"}</div>
                    </div>
                )}
            </>
        )
      
    }
    //일자별 그룹 리스트
    Orderrender() {
        const DataMaster = this.state.OrdMgtMaster;
        const DayGroups = Big3Common.Util.groupBy(DataMaster, list => list.ord_dt);
        const OrdDtListJson = [];
        for (const item of DayGroups.entries()) {
            OrdDtListJson.push({
                "Ord_Dt": item[0],
                "OrderList": item[1],
            });
        }
        return (
            <>
                {OrdDtListJson.map((list,idx) =>
                    <div className="order_one_day_box" key={idx}>
                        <div className="date">{list.Ord_Dt}</div>
                        {this.WholeInforender(list.OrderList) }
                    </div>
                )}
            </>
         )
    } 
   
    render() {
        const Orderrender = this.Orderrender();
        //사입완료 건수
        const WorkCp = this.state.DetailNote.filter(list => list.last_appr_status === "CP").length;
        //상품주문 건수
        let OrderCount = this.state.DetailPlatform.length;
        //순수 사입건수
        const OriginSS = this.state.OrdMgtMaster.filter(list => list.uid === '').length;
        OrderCount = OrderCount + OriginSS;
        

        this.Dashboardrender=()=> {
            if (this.state.CancelListYn === "Y") {
                return "";
            }
            else {
                if (this.Uid_Type === 'TS') {
                    return (
                        <div className="total_order_list_box">
                            <div className="order_list_box">
                                <div className="order_list first">
                                    <div className="tit">총 주문</div>
                                    <div className="number">{Big3Common.Util.Money(OrderCount)}건</div>
                                </div>
                                <div className="order_list">
                                    <div className="tit">픽업완료</div>
                                    <div className="number">{Big3Common.Util.Money(WorkCp)}건</div>
                                </div>
                            </div>
                        </div>
                    )
                }
                else {
                    return (
                        <div className="total_order_list_box">
                            <div className="order_list_box">
                                <div className="order_list first">
                                    <div className="tit">총 주문</div>
                                    <div className="number">{Big3Common.Util.Money(OrderCount)}건</div>
                                </div>
                                <div className="order_list">
                                    <div className="tit">사입완료</div>
                                    <div className="number">{Big3Common.Util.Money(WorkCp)}건</div>
                                </div>
                            </div>
                            <div className="ap">총 대납비는 <span>{Big3Common.Util.Money(this.state.SumBuyamt)}원</span> 입니다.</div>
                        </div>
                    )
                }
            }
        }
        return (
            <>
                <div className="tap_box">
                    <div className="n_tap" onClick={(e) => { this.handleTab_Click(e, 'N') }}>
                        <div className={this.state.CancelListYn === "N" ? "alert_tap tap_on" : "alert_tap"}>주문목록</div>
                    </div>
                    <div className="n_tap" onClick={(e) => { this.handleTab_Click(e, 'Y') }}>
                        <div className={this.state.CancelListYn === "N" ? "alert_tap" : "alert_tap tap_on"}>취소목록</div>
                    </div>
                </div>
                <div className="container_box2 orderlist_box order_list_v2">
                    <div className="search_wrap ">
                        <div className="search_input_box">
                            <input type="text" placeholder="도매상호명 또는 도매호수를 입력해주세요."
                                className="form-control"
                                onChange={this.handleSearchText_Change}
                                value={this.state.SearchText}
                                onKeyUp={this.handleSearchText_Keyup}
                            />
                            <div className="search_btn"></div>
                            <div className="search_delete" onClick={() => { this.setState({ SearchText: '' }) }}></div>
                        </div>
                        <div className="select_date_box">
                            <div className="select_date_box_input">
                                <Big3DatePicker
                                    className="form-control"
                                    setDate={new Date(this.state.FromDate)}
                                    DateChange={this.handleCalendarChange}
                                    id="FromDate"
                                />
                                <div className="calendar_btn"></div>
                            </div>
                            <div className="select_date_box_input">
                                <Big3DatePicker
                                    className="form-control"
                                    setDate={new Date(this.state.ToDate)}
                                    DateChange={this.handleCalendarChange}
                                    id="ToDate"
                                />
                                <div className="calendar_btn"></div>
                            </div>
                            <button type="button" className="date_s_btn" onClick={() => { this.CallOrdMgtListData(); }}>조회</button>
                        </div>
                    </div>
                    {this.Dashboardrender()}
                    <div className="select_box">
                        <div className="order_select_box">
                            <ComboBox id="ordIdx"
                                textName="dtl_nm"
                                valueName="dtl_cd"
                                emptyText="전체보기"
                                optionList={this.OrdIdx}
                                ComboChange={this.handleCombo_Change}
                                className=""
                            />
                            <div className="select_btn"></div>
                        </div>
                    </div>
                </div>
                <div className="container_box_v2">
                    {Orderrender }
                </div>
                <NoResult
                    Visible={this.state.OrdMgtMaster.length === 0 ? true : false}
                    Top={"65%"}
                />
                <Alert
                    id="MessageAlert"
                    content={this.state.Content}
                    title="입력안내"
                />
                <Alert
                    id="CompleteCancel"
                    content={this.state.Content}
                    title="취소완료"
                />
                <Confirm
                    id="CancelConfirm"
                    title="취소 하시겠습니까?"
                    content="완료되지 않은 사입내역이 존재하면<br/> 사입내역까지 취소 합니다."
                    ConfirmClick={() => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, 'CancelConfirm');
                        }, 500);
                        this.handleCancel_Post()
                    }}
                />
                <Confirm
                    id="CompleteConfirm"
                    title="수령완료처리 하시겠습니까?"
                    content="수령완료는 도매와 소매 거래가 완료됨을 의미합니다."
                    ConfirmClick={() => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, 'CompleteConfirm');
                        }, 500);
                        this.handleComplete_Post()
                    }}
                />
                <OrderMgrDtl
                    id="OrderMgrDtl"
                    ref={this.OrderMgrDtlRef}
                    ModalOpen={true}
                />
            </>
        );
    }
}
